function isRTLLanguage(word) {
  const isLatin = new RegExp(/[a-zA-Z]+/);
  const isHebrew = new RegExp(/[\u0590-\u05FF]+/);
  const isArabic = new RegExp(/[\u0600-\u06ff\u0750-\u077f\ufb50-\ufbc1\ufbd3-\ufd3f\ufd50-\ufd8f\ufd92-\ufdc7\ufe70-\ufefc\uFDF0-\uFDFD]+/);

  if (isLatin.test(word)) return false;
  else if (isHebrew.test(word) || isArabic.test(word)) return true;
  
  return false;
}

export function getTextDirection(message) {
  if (isRTLLanguage(message.split(' ')[0])) return 'rtl'
  else return 'ltr'
}